import React from 'react'
import { Loader as GoogleMapsLoader, LoaderStatus } from '@googlemaps/js-api-loader'
import { IS_LOCAL } from 'src/config'
import { growlError } from 'src/components/growl'

// export const MAP_ID_NO_POI = '9739041cd77f55fe'
export const MAP_ID = IS_LOCAL ? '51a1e02523712b16' : '8c8910e03bb7e4f'
export const GOOGLE_API_KEY = process.env.GOOGLE_MAPS_API_KEY as string

type LoaderProps = {
  children?: React.ReactNode
}

const loader = new GoogleMapsLoader({
  apiKey: GOOGLE_API_KEY,
  version: 'weekly',
  mapIds: [MAP_ID],
})

export const Loader = (props: LoaderProps) => {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect(() => {
    if (loader.status !== LoaderStatus.INITIALIZED) {
      if (loaded === false) {
        setLoaded(true)
      }
      return
    }

    const importMaps = loader.importLibrary('maps')
    const importPlaces = loader.importLibrary('places')
    const importDrawing = loader.importLibrary('drawing')
    const importGeometry = loader.importLibrary('geometry')
    const importVisualization = loader.importLibrary('visualization')

    Promise.all([importMaps, importPlaces, importDrawing, importGeometry, importVisualization])
      .then(() => {
        setLoaded(true)
      })
      .catch((e) => growlError(e, 'Unable to load google maps sdk'))
  }, [])

  if (!loaded) {
    return null
  }

  return <>{props.children}</>
}
